<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo //CAMBIAR!!!-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <img src="/logo-new.png" alt="Logo" style="width: 2rem; height: 2rem;">
        <h2 class="brand-text text-success ml-1">
          Habit 
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex flex-column align-items-center justify-content-center px-5">
          <!-- <b-img
            :src="imgUrl"
            fluid
            alt="Reset password"
          /> -->
          <!-- <vuexy-logo :size="200"/> -->
          <img src="/logo-new.png" alt="Logo" style="width: 10rem; height: 10rem;">
          <h6 class="mt-4 text-success text-center" style="line-height: 1.5;">
             {{ $t('message.msgSlogan1') }}<br>{{ $t('message.msgSlogan2') }}
          </h6>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            {{ $t('message.ResetPassword') }} 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('message.msgResetPassword') }}
          </b-card-text>

          <!-- success message -->
          <div v-if="successMessage" class="d-flex align-items-center text-success mb-2">
            <feather-icon icon="CheckCircleIcon" size="18" class="mr-1" />
            <div>
              <strong>{{ $t('message.password_updated_success_title') }}</strong><br>
              <small>{{ $t('message.password_updated_success_description') }}</small>
            </div>
          </div>

          <!-- form -->
          <validation-observer v-if="!successMessage" ref="simpleRules">
            <b-form
              class="auth-reset-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <!-- verification code -->
              <b-form-group
                :label="$t('message.verification_code')"
                label-for="reset-verification-code"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('message.verification_code')"
                  rules="required"
                >
                  <b-form-input
                    id="reset-verification-code"
                    v-model="verificationCode"
                    :state="errors.length > 0 ? false : null"
                    name="reset-verification-code"
                    :placeholder="$t('message.enter_code_placeholder')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password requirements -->
              <div class="mb-1 p-1 border rounded">
                <small class="d-block font-weight-bold mb-50">{{ $t('message.password_requirements_title') }}</small>
                <div v-for="(req, idx) in requirements" :key="idx" class="d-flex align-items-center mb-25">
                  <feather-icon
                    :icon="req.met ? 'CheckIcon' : 'XIcon'"
                    size="14"
                    :class="req.met ? 'text-success' : 'text-danger'"
                    class="mr-50"
                  />
                  <small :class="req.met ? 'text-success' : 'text-danger'">{{ req.label }}</small>
                </div>
              </div>

              <!-- new password -->
              <b-form-group
                :label="$t('message.New_Password')"
                label-for="reset-password-new"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="reset-password-new"
                    v-model="password"
                    :type="password1FieldType"
                    class="form-control-merge"
                    name="reset-password-new"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="password1ToggleIcon"
                      @click="togglePassword1Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                :label="$t('message.ConfirmPassword')"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="reset-password-confirm"
                    v-model="cPassword"
                    :type="password2FieldType"
                    class="form-control-merge"
                    name="reset-password-confirm"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="password2ToggleIcon"
                      @click="togglePassword2Visibility"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <!-- submit button -->
              <b-button
                block
                type="submit"
                variant="primary"
                :disabled="isSubmitting || !allRequirementsMet || !passwordsMatch || !verificationCode"
              >
                {{ $t('message.SetNewPassword') }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('message.BackToLogin') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton, BImg,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useCognito } from '@/views/habit/awsCognito'

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BImg,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      verificationCode: '',
      cPassword: '',
      password: '',
      isSubmitting: false,
      successMessage: false,
      required,
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    requirements() {
      return [
        { label: this.$t('message.password_req_length'), met: this.password.length >= 8 && this.password.length <= 12 },
        { label: this.$t('message.password_req_uppercase'), met: /[A-Z]/.test(this.password) },
        { label: this.$t('message.password_req_number'), met: /[0-9]/.test(this.password) },
        { label: this.$t('message.password_req_symbol'), met: /[@#$%&]/.test(this.password) },
      ]
    },
    allRequirementsMet() {
      return this.requirements.every(r => r.met)
    },
    passwordsMatch() {
      return this.password === this.cPassword && this.cPassword.length > 0
    },
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    this.userEmail = this.$route.query.email || ''
    if (!this.userEmail) {
      this.$router.replace({ name: 'auth-forgot-password' })
    }
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.isSubmitting = true
          try {
            await useCognito().confirmForgotPassword(this.userEmail, this.verificationCode, this.password)
            this.successMessage = true
            setTimeout(() => { this.$router.push({ name: 'auth-login' }) }, 2000)
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('message.error_updating_password'),
                text: error.message,
                icon: 'EditIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
